<div class="dash_base mt-2" *ngIf="onboardRequestLoading">
  <div class="flex_center fullHeight">
    <mat-spinner [diameter]="30" class="mr-3"></mat-spinner> Please wait while we load
  </div>
</div>
